import React from "react";
import { BiBook } from "react-icons/bi";
import { BsDatabase } from "react-icons/bs";
import { GrDeploy } from "react-icons/gr";
import { HiAdjustmentsVertical } from "react-icons/hi2";
import { useLanguage } from "../Translations/LenguageContext";

const How = () => {
    const { t } = useLanguage();
    const steps = t.howItWorks.steps;

    return (
        <div className="how_cont fade-in">
            <h3>{t.howItWorks.title}</h3>
            <div className="how_card_cont">
                <div className="how_card">
                    <p className="how_card_icon"><BsDatabase /></p>
                    <p className="how_card_title">{steps.secureData.title}</p>
                    <p className="how_card_desc">{steps.secureData.desc}</p>
                </div>
                <div className="how_card">
                    <p className="how_card_icon"><HiAdjustmentsVertical /></p>
                    <p className="how_card_title">{steps.trainModel.title}</p>
                    <p className="how_card_desc">{steps.trainModel.desc}</p>
                </div>
                <div className="how_card">
                    <p className="how_card_icon"><GrDeploy /></p>
                    <p className="how_card_title">{steps.deployInstantly.title}</p>
                    <p className="how_card_desc">{steps.deployInstantly.desc}</p>
                </div>
                <div className="how_card">
                    <p className="how_card_icon"><BiBook /></p>
                    <p className="how_card_title">{steps.continuousLearning.title}</p>
                    <p className="how_card_desc">{steps.continuousLearning.desc}</p>
                </div>
            </div>
        </div>
    );
}

export default How;
